import { styled } from '@mui/system';
import { AgColor } from '../../../stories/Styles/AgColor';

export const Card = styled('section')`
  border: 1px solid ${AgColor.grey3};
  box-sizing: border-box;
  border-radius: 8px;
  padding: 12px 16px;
  width: 216px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${AgColor.grey0};
  box-shadow: 0px 1px 2px 0px #0000000d;
`;

export const IDCard = styled('section')`
  border: 1px solid ${AgColor.grey6};
  box-sizing: border-box;
  border-radius: 4px;
  width: 420px;
  height: 235px;
`;
